import { all, takeEvery, put, call } from "redux-saga/effects";
import { getCategories } from "../../api/category";
import { GET_LIST_CATEGORY, GET_LIST_CATEGORY_FAILURE, GET_LIST_CATEGORY_SUCCESS } from "./actions";

interface CategoryResponse {
  statusCode?: number;
  message?: string;
  result?: any[];
}

interface Error {
  message: string;
}

export function* sagaGetCategories(action: { type: string; payload: { page: number; limit: number; search: string } }) {
  try {
    const { page = 1, limit = 10, search = '' } = action.payload

    const res: CategoryResponse = yield call(getCategories, {page, limit, search});

    if (res && !res.statusCode) {
      yield put({
        type: GET_LIST_CATEGORY_SUCCESS,
        payload: res?.result,
      });
      return;
    }

    yield put({
      type: GET_LIST_CATEGORY_FAILURE,
      payload: res?.message || "An error occurred",
    });
  } catch (error: unknown) {
    const errorMessage = (error instanceof Error) ? error.message : 'Unknown error occurred';
    yield put({
      type: GET_LIST_CATEGORY_FAILURE,
      payload: errorMessage,
    });
  }
}

export default function* rootSaga() {
  yield all([takeEvery(GET_LIST_CATEGORY, sagaGetCategories)]);
}
